import { useStaticQuery, graphql } from "gatsby"

const cookieQuery = graphql`
  query CookieQuery {
    cookie: craftGlobalSetInterface {
      ... on Craft_cookieConsentBanner_GlobalSet {
        id
        excerpt
        ctaLink {
          target
          text
          type
          url
          element {
            ... on Craft_EntryInterface {
              uri
            }
          }
        }
      }
    }
  }
`

export const useCookie = () => {
  const { cookie } = useStaticQuery(cookieQuery)

  return cookie
}
